import { createFileRoute } from '@tanstack/react-router';
import VehiclesSettings from '../../components/VehiclesSettings';
import { PERMISSION_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/cars_settings/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_VEHICLE, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.carsSettings',
        suffix: 'menu.settings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: VehiclesSettingsRoute,
});

function VehiclesSettingsRoute() {
  return <VehiclesSettings />;
}
